import { render, staticRenderFns } from "./ActivosPorContrato.vue?vue&type=template&id=21521389&scoped=true"
import script from "./ActivosPorContrato.vue?vue&type=script&lang=js"
export * from "./ActivosPorContrato.vue?vue&type=script&lang=js"
import style0 from "./ActivosPorContrato.vue?vue&type=style&index=0&id=21521389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21521389",
  null
  
)

export default component.exports